/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum PackagePricingMethod {
  Legacy = 0,
  Free = 10,
  FixedPrice = 15,
  Business = 20,
  BusinessTrial = 25,
  Accounting = 30,
  AccountingTrial = 35,
  BusinessMultiProduct = 40,
  AccountingMultiProduct = 50,
}
